import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import OptionsMenu from './OptionsMenu';
import { ReactComponent as Logo } from '../../images/logo.svg';
import { useSelector } from 'react-redux';
import { FE_APP_VERSION } from '../../../utils/config';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu() {

  const user = useSelector((state) => state.auth.user) || null;
  const constants = useSelector(state => state?.constants?.data);

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          mt: 'calc(var(--template-frame-height, 0px) + 0px)',
          p: 1.2,
          bgcolor: '#ffd300', // Add this line to set the background color
        }}
      >
        <Logo />
        <Typography
          variant="h6"
          component="h1"
          sx={{ mt: 1}}
        >
          The AA - Backstop
        </Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* <Typography
          variant="h6"
          component="h1"
          sx={{ color: "rgba(0, 0, 0, 0.54)", padding: '15px 25px', display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          The AA - Backstop
        </Typography>
        <Divider sx={{ margin: '0 20px' }} /> */}
        <MenuContent />
        
      </Box>
      <Box sx={{pl: 2, fontSize:'11px', color: '#444444'}}>UI version: {FE_APP_VERSION}</Box>
      <Box sx={{pl: 2, fontSize:'11px', color: '#444444'}}>API version: {constants?.apiVersion}</Box>
      { user && 
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Avatar
          sizes="small"
          alt={user.name}
          src="/static/images/avatar/7.jpg"
          sx={{ width: 36, height: 36 }}
        />
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {user.username}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {user.email}
          </Typography>
        </Box>
        <OptionsMenu />
      </Stack> }
    </Drawer>
  );
}
